var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClover = function SvgClover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67213 1.99902C9.25224 1.99902 11.3453 4.09308 11.3453 6.67166V11.3443H6.67315C4.09203 11.3443 2 9.24772 2 6.66913C2 4.09004 4.09203 1.99902 6.67213 1.99902Z",
    fill: "#228800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3308 1.99902C14.7496 1.99902 12.6566 4.09308 12.6566 6.67166V11.3443H17.3287C19.9109 11.3443 22.0019 9.24772 22.0019 6.66913C22.0019 4.09004 19.9109 1.99902 17.3308 1.99902Z",
    fill: "#228800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6566 17.3283C12.6566 19.9099 14.7486 22.0009 17.3308 22.0009C19.9098 22.0009 22.0019 19.9114 22.0019 17.3298C22.0019 14.7512 19.9098 12.6556 17.3287 12.6556H12.6566V17.3283Z",
    fill: "#228800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67112 22.0009C9.25325 22.0009 11.3453 19.9099 11.3453 17.3283V12.6556H6.67315C4.09203 12.6556 2 14.7512 2 17.3298C2 19.9114 4.09203 22.0009 6.67112 22.0009ZM10.035 17.3298C10.035 19.1793 8.5262 20.6835 6.67112 20.6835C4.81806 20.6835 3.3103 19.1793 3.3103 17.3298C3.3103 15.4813 4.82009 13.9669 6.67517 13.9669H10.035V17.3298Z",
    fill: "#228800"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "clover.333c6fcaed81ad899062d942a051f920.svg";